import type { SerializedNode } from "@craftjs/core";

import logger from "@/utils/logger";

import getResolveableNodes from "./get-resolveable-nodes";

export default function serializePageContent(
  content: Record<string, SerializedNode>,
  blocks: Record<string, any>
): string {
  try {
    const resolveableNodes = getResolveableNodes(content, blocks);
    const stringified = JSON.stringify(resolveableNodes);
    const parsed = JSON.parse(stringified);

    if (typeof parsed === "object") {
      return stringified === "{}" ? null : stringified;
    }

    return null;
  } catch (error) {
    logger.error(error, {
      details: "invalid content object",
    });
    return null;
  }
}
